<template>
	<div class="col">
		<div class="card shadow-2-hover h-100">
			<div class="card-body vstack gap-1">
				<div class="text-md text-muted lh-xs">
					<i class="bi" :class="`bi-${icon}`"></i>
				</div>
				<div class="vstack lh-1">
					<router-link :to="link" class="h5 stretched-link">{{ title }}</router-link>
					<p class="text-sm">{{ description }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			icon: String,
			title: String,
			description: String,
			link: Object
		}
	}
</script>